import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkIsLoggedIn } from "../../Features/Authentication/authSlice";

function PrivateRoute() {
  const isLoggedIn = useSelector(checkIsLoggedIn);
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoute;
